import Promise from 'bluebird'
import Cookies from 'js-cookie'
import { upper, lower } from './functions'
import { NoCookieError } from './errors'

export const COOKIE_SELECTED_VEHICLE = 'VELOX_SELECTED_VEHICLE'
export const COOKIE_SELECTED_WHEEL = 'VELOX_SELECTED_WHEEL'
export const COOKIE_SELECTED_QUANTITY = 'VELOX_SELECTED_QUANTITY'

export const COOKIE_USER_TOKEN = 'VELOX_USER_TOKEN'
export const COOKIE_USER = 'VELOX_USER'

export const COOKIE_SETTINGS = {
	expires: 31, // 31 days,
}
export const SECURE_COOKIE_SETTINGS = Object.assign({}, COOKIE_SETTINGS, { secure: true, sameSite: 'strict' })

export class Cookie{
	constructor(name, value=null, settings={ expires: 7 }){
		this.name = name
		this.value = value
		this.settings = settings
		if( value ){
			this.set(value, settings)
		}
		this.remove = this.delete
	}
	set = (value, settings) => Cookies.set(this.name, value, settings || this.settings)
	get = () => Cookies.get(this.name)
	delete = (settings=null) => Cookies.remove(this.name, settings || this.settings)
	resolve = () =>{
		var cookie_value = this.get()
		return new Promise( (resolve, reject) => {
			if( !cookie_value ){
				reject( new NoCookieError('Could not retrieve current_vehicle value from cookie') )
			}
			try{
				cookie_value = JSON.parse(cookie_value)
				resolve( cookie_value )
			}catch(e){
				reject( new NoCookieError('Could not retrieve current_vehicle value from cookie') )
			}
		})
	}
}

// Application Cookies
export const SelectedVehicleCookie = new Cookie( COOKIE_SELECTED_VEHICLE, null, COOKIE_SETTINGS );
export const SelectedWheelCookie = new Cookie( COOKIE_SELECTED_WHEEL, null, COOKIE_SETTINGS );
export const SelectedQtyCookie = new Cookie( COOKIE_SELECTED_QUANTITY, 4, COOKIE_SETTINGS );
export const UserTokenCookie = new Cookie( COOKIE_USER_TOKEN, null, SECURE_COOKIE_SETTINGS );
export const UserCookie = new Cookie( COOKIE_USER, null, SECURE_COOKIE_SETTINGS );

// Functions
export const save_vehicle_cookie = SelectedVehicleCookie.set
export const resolve_vehicle_cookie = SelectedVehicleCookie.resolve
export const save_wheel_cookie = SelectedWheelCookie.set
export const resolve_wheel_cookie = SelectedWheelCookie.resolve
export const save_qty_cookie = SelectedQtyCookie.set
export const resolve_qty_cookie = SelectedQtyCookie.resolve
export const save_user_cookie = UserCookie.set
export const resolve_user_cookie = UserCookie.resolve
export const delete_user_cookie = UserCookie.delete
export const save_user_token_cookie =  UserTokenCookie.set
export const resolve_user_token_cookie = UserTokenCookie.resolve
export const delete_user_token_cookie = UserTokenCookie.delete


export function resolve_cookie(cookie_name){
	return new Promise( (resolve, reject) => {
		var cookie_value = Cookies.get(cookie_name)
		if( !cookie_value ){
			reject( new NoCookieError('Could not retrieve current_vehicle value from cookie') )
		}
		try{
			cookie_value = JSON.parse(cookie_value)
			resolve( cookie_value )
		}catch(e){
			resolve( cookie_value )
		}
	})
}
